import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Tabs } from '@ifs-gcp/components';

import { useAuditStore } from '@/store/auditStore';
import { useRouterStore } from '@/store/routerStore';
import { getTranslation } from '@/utils/translations';

import { createTabs } from '../utils';

export const NavTabs = () => {
  const audit = useAuditStore((state) => state.audit);

  const selectedTabIndex = useRouterStore((state) => state.selectedTabIndex);
  const tabs = useRouterStore((state) => state.tabs);
  const setTabs = useRouterStore((state) => state.setTabs);
  const setSelectedTabId = useRouterStore((state) => state.setSelectedTabId);
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    if (!audit) {
      throw new Error('Audit data is not available');
    }

    setTabs(createTabs(audit.templateHandler.schema));
  }, []);

  const groupedMenuItems = tabs.map(({ label, ...tab }) => {
    if (Array.isArray(label)) {
      const matchedTabName = label.find((tabName) =>
        audit?.conditions.validate(tabName.visibilityCondition),
      );

      if (!matchedTabName) {
        return { ...tab, label: '' };
      }

      return { ...tab, label: getTranslation(matchedTabName.text, language) };
    }

    return { ...tab, label: getTranslation(label, language) };
  });

  const handleNavigate = (newIndex: number) => {
    setSelectedTabId(tabs[newIndex].id);
  };

  return (
    <Tabs
      items={groupedMenuItems}
      value={selectedTabIndex}
      onNavigate={handleNavigate}
      isActiveGroupMustNotBeHighlighted={false}
    />
  );
};
